import { all, put, takeEvery, fork } from "redux-saga/effects";
import { apiURL } from "../actions/helpers";
import axios from "axios";
// Action Types
export const STREAMS_LOAD = "STR/LOAD/TOP";
export const STREAMS_LOAD_SUCCESS = "STR/LOAD/TOP/SUCCESS";
export const STREAMS_LOAD_FAILURE = "STR/LOAD/TOP/FAILURE";

// Action Creators
export const streamsLoad = (endpoint, page = 1, total = 100, per_page = 9) => ({
  type: STREAMS_LOAD,
  endpoint,
  page,
  total,
  per_page,
});
export const streamsLoadSuccess = (data) => ({
  type: STREAMS_LOAD_SUCCESS,
  data,
});
export const streamsLoadFailure = (error) => ({
  type: STREAMS_LOAD_FAILURE,
  error,
});
// Sagas
function* fetchPastStreams(action) {
  const { endpoint, page, total, per_page } = action;
  try {
    const final = {
      streams: [],
      loading: true,
      page,
      total,
    };
    yield put(streamsLoadSuccess(final));
    const url = `${apiURL}/videos/${endpoint}?page=${page}&per_page=${per_page}`;
    const { data } = yield axios.get(url, { withCredentials: true });
    final.streams = data?.data?.data || [];
    final.loading = false;
    final.page = data?.data?.page;
    final.total = data?.data?.total;
    yield put(streamsLoadSuccess(final));
  } catch (error) {
    yield put(streamsLoadFailure(error));
  }
}

function* listenFetchStreamsLoad() {
  yield takeEvery(STREAMS_LOAD, fetchPastStreams);
}

// Root Saga
export function* saga() {
  yield all([fork(listenFetchStreamsLoad)]);
}

const INIT_STATE = {
  streams: [],
  loading: true,
  page: 1,
  total: 100,
  error: null,
};
// Reducer
const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case STREAMS_LOAD:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case STREAMS_LOAD_SUCCESS:
      return {
        ...state,
        streams: action.data.streams,
        loading: action.data.loading,
        total: action.data.total,
        error: null,
      };
    case STREAMS_LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
        // do not change current streams to preserve last successful state
      };
    default:
      return state;
  }
};

export default reducer;
